import React, { useCallback } from 'react';
import { FlatList } from 'react-native';
import { Button, Text } from '@rneui/themed';
import { View } from '@annunciate/ui';
import { Comment } from './Comment';
import { useCommentsQuery } from '../hooks';
import { CommentForm } from './CommentForm';
export const Comments = ({ discussionId, endpoint, parentId, depth, maxDepth, manualLoad = true, displayMeta = false, displayCreate = false, }) => {
    const { queryKey, isFetchingNextPage, isFetchingPreviousPage, hasNextPage, data, fetchNextPage, remainingCount, count, } = useCommentsQuery({
        discussionId,
        parentId,
        endpoint,
    });
    const isLoadingPage = isFetchingNextPage || isFetchingPreviousPage;
    const renderItem = useCallback(({ item, }) => (React.createElement(Comment, { comment: item, discussionId: discussionId, endpoint: endpoint, queryKey: queryKey, depth: depth, maxDepth: maxDepth })), [discussionId, endpoint, queryKey, depth, maxDepth]);
    return (React.createElement(View, { style: { flex: 1, width: '100%' } },
        React.createElement(FlatList, { style: { width: '100%' }, keyExtractor: (item, index) => `${item.id}-${index}`, data: data, renderItem: renderItem, onEndReached: () => {
                if (!manualLoad) {
                    if (hasNextPage)
                        fetchNextPage();
                }
            }, onEndReachedThreshold: 0.5, onScrollToIndexFailed: () => { }, ListHeaderComponent: (React.createElement(React.Fragment, null,
                displayMeta && (React.createElement(View, null,
                    React.createElement(Text, { h2: true, bold: true },
                        count,
                        " ",
                        count === 1 ? 'Comment' : 'Comments'))),
                displayCreate && (React.createElement(CommentForm, { discussionId: discussionId, endpoint: endpoint, parentId: parentId, onClose: () => console.log('on close'), onSubmitSuccess: () => { }, queryKey: queryKey })))) }),
        isLoadingPage && (React.createElement(Text, null, "Loading...")),
        manualLoad && hasNextPage && (React.createElement(Button, { style: { marginTop: 15 }, onPress: () => fetchNextPage() },
            "Load More Comments ",
            remainingCount ? `(${remainingCount})` : undefined))));
};
//# sourceMappingURL=Comments.js.map